import { render } from "./TodayLectureTeacher.vue?vue&type=template&id=1932a40b&scoped=true"
import script from "./TodayLectureTeacher.vue?vue&type=script&lang=js"
export * from "./TodayLectureTeacher.vue?vue&type=script&lang=js"

import "./TodayLectureTeacher.vue?vue&type=style&index=0&id=1932a40b&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1932a40b"]])

export default __exports__